import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Validators } from '@angular/forms';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-sec002-card-VI',
    templateUrl: './sec002-card-VI.component.html'
})

export class Sec002CardVIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listOptionsDestino?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsMotivo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsDestinoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listOptionsMotivoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public filteredOptionsDestino: Observable<DropDownListDTO[]>;

    @Output() mkCalc = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Controle de Silos', false);
        if (this.isComercial) {
            this.formulario = this.formBuilder.group({
                Inicio_transilagem_data: [null, [Validators.pattern(this.regexDate)]],
                Inicio_transilagem_hora: [null, [Validators.pattern(this.regexHour)]],
                Silo_destino_transilagem: [null, []],
                Motivo: [null, []],
                Inicio_retirada_armazem_data: [null, [Validators.pattern(this.regexDate)]],
                Inicio_retirada_armazem_hora: [null, [Validators.pattern(this.regexHour)]],
                Inicio_retorno_silo_data: [null, [Validators.pattern(this.regexDate)]],
                Inicio_retorno_silo_hora: [null, [Validators.pattern(this.regexHour)]],
                Silo_destino_retorno: [null, []],
                Local_atual: [null, []],
                Inicio_descarga_silo_data: [null, [Validators.pattern(this.regexDate)]],
                Inicio_descarga_silo_hora: [null, [Validators.pattern(this.regexHour)]],
                Destino_ds_final: [null, []],
                Armazenagem_dias: [null, []],
            });
        } else {
            this.formulario = this.formBuilder.group({});
        }

    }

    public async ngOnInit(): Promise<void> {
        await Promise.all([this.getListDestino(), this.getListMotivo()]);
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    private async getListDestino(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'destino_ds_final').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsDestino = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsDestinoOriginal = this.listOptionsDestino;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    private async getListMotivo(): Promise<void> {
        await this.formularioService.getListDropDownList('sec002', 'motivo').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listOptionsMotivo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listOptionsMotivoOriginal = this.listOptionsMotivo;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async createFilterDestino(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsDestinoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsDestino = this.listOptionsDestinoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsDestino = this.listOptionsDestinoOriginal;
            }
        } else {
            this.listOptionsDestino = this.listOptionsDestinoOriginal;
        }
    }

    async createFilterMotivo(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listOptionsMotivoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listOptionsMotivo = this.listOptionsMotivoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listOptionsMotivo = this.listOptionsMotivoOriginal;
            }
        } else {
            this.listOptionsMotivo = this.listOptionsMotivoOriginal;
        }
    }
}
